import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ComputedRef, computed } from "vue";
import { useStore } from "vuex";
import TwLabel from "../TwLabel.vue";
import TwButtonsYesAndNo from "../TwButtonsYesAndNo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: '5.HaveTanningLast48Hours',
  setup(__props) {

const store = useStore();

const haveYouTanningLast48Hours: ComputedRef<boolean> = computed(
  () => store.state.form.have_you_tanning_last_48_hours
);
const updateHaveYouTanningLast48Hours = (value: boolean) => {
  store.dispatch("updateHaveYouTanningLast48Hours", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[haveYouTanningLast48Hours.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("have_you_tanning_last_48_hours")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwButtonsYesAndNo, {
      isActive: haveYouTanningLast48Hours.value,
      onOnClickYes: _cache[0] || (_cache[0] = ($event: any) => (updateHaveYouTanningLast48Hours(true))),
      onOnClickNo: _cache[1] || (_cache[1] = ($event: any) => (updateHaveYouTanningLast48Hours(false)))
    }, null, 8, ["isActive"])
  ], 2))
}
}

})